export enum MessagesRoutes {
  ROOT = '',
  CHAT = 'chat'
}
